import { cn } from "$/lib/utils/functions/misc.functions";
import { useMemo, type PropsWithChildren } from "react";
import Flexbox, { type FlexboxProps } from "../../common/Flexbox";
import { useScreen } from "usehooks-ts";
import { CONTAINER_HEIGHT_PERCENTAGE, MID_CONTAINER_HEIGHT_PERCENTAGE } from "$/lib/utils/functions/marketMonitoring/graphs.functions";

const ChartsContainer = ({
  children,
  className,
  ...props
}: PropsWithChildren<FlexboxProps> & { midHeight?: boolean }) => {
  const { midHeight, ...rest } = props;

  const { height: screenHeight } = useScreen();

  const graphHeight = useMemo(
    () =>
      Math.round(
        screenHeight *
          (midHeight
            ? MID_CONTAINER_HEIGHT_PERCENTAGE
            : CONTAINER_HEIGHT_PERCENTAGE),
      ),
    [midHeight, screenHeight],
  );

  return (
    <Flexbox
      row
      fullWidth
      align="stretch"
      className={cn("p-4 relative", className)}
      style={{
        height: graphHeight + "px",
      }}
      {...rest}
    >
      {children}
    </Flexbox>
  );
};

export default ChartsContainer;
